<app-popup-layout #modal>
  <header class="modal-header">
    <app-close-button class="ms-auto" (onCloseEmitter)="modal.dismiss()"></app-close-button>
  </header>
  <div class="modal-container">
    <div class="left-section mt-2">
      <p class="title mt-2">eRUPI Vouchers</p>
      <p class="sub-title px-24 mb-0">
        Transform your payment processes with eRUPI Vouchers. This digital, contactless solution simplifies the
        distribution and redemption of vouchers, making it perfect for managing petty cash. Ensure a hassle-free
        experience for both issuers and recipients, and streamline your petty cash operations with ease.
      </p>

      <div class="md-stepper-horizontal">
        <div class="md-step">
          <div class="circle">
            <div class="inner-circle"></div>
          </div>
          <div class="stepper-text mt-3 mx-3">Configure eRUPI Voucher Account</div>
          <div class="md-step-bar-left"></div>
          <div class="md-step-bar-right"></div>
        </div>
        <div class="md-step">
          <div class="circle">
            <div class="inner-circle"></div>
          </div>
          <div class="stepper-text mt-3 mx-3">
            Load funds and issue eRUPI Vouchers
          </div>
          <div class="md-step-bar-left"></div>
          <div class="md-step-bar-right"></div>
        </div>
        <div class="md-step">
          <div class="circle">
            <div class="inner-circle"></div>
          </div>
          <div class="stepper-text mt-3 mx-3">Track eRUPI Vouchers Spendings</div>
          <div class="md-step-bar-left"></div>
          <div class="md-step-bar-right"></div>
        </div>
      </div>

      <section class="d-flex flex-col align-items-center">
        <p class="mb-2 exp-text">
          Want to experience the benefits of eRUPI Vouchers Automation?
        </p>

        <button mat-flat-button color="primary" class="custom-button" (click)="onSetup()"
          [appLoaderButton]="formActionRequestState()">
          {{ title }}
        </button>
      </section>
    </div>

    <div class="right-section">
      <img src="assets/svg/erupi-enterprise.svg" class="meal-card-enkash" alt="eRupi Voucher" />
    </div>
  </div>
  <div class="footer pb-12">
    <p class="footer-title mt-2 mb-16">Key Features of EnKash eRUPI Vouchers</p>
    <section class="footer-grouping">
      <section class="footer-header">
        <img src="assets/svg/petty-cash-complete-control.svg" class="footer-img" alt="Complete Control" />
        <p class="footer-header-title mb-0">Complete Control</p>
        <p class="footer-header-sub-title mx-3">
          Manage Vouchers and all transactions for employee
        </p>
      </section>

      <section class="footer-header">
        <img src="assets/svg/petty-cash-intutive.svg" class="footer-img" alt="Intuitive" />
        <p class="footer-header-title mb-0">Intuitive</p>
        <p class="footer-header-sub-title">
          Experience seamless and digital small-ticket size QR based payments
        </p>
      </section>

      <section class="footer-header">
        <img src="assets/svg/petty-cash-fortify.svg" class="footer-img" alt="Fortify" />
        <p class="footer-header-title mb-0">Fortify</p>
        <p class="footer-header-sub-title mx-3">
          Seal financial leakages and bid farewell to hard-cash challenges
        </p>
      </section>

      <section class="footer-header px-3">
        <img src="assets/svg/petty-cash-automation.svg" class="footer-img" alt="Automations" />
        <p class="footer-header-title mb-0">Automations</p>
        <p class="footer-header-sub-title">Say Goodbye to Receipt Hassles</p>
      </section>
    </section>

    <!-- <section>
      <p>Flexibility</p>
      <p>
        Ease of onboarding, advance controls for admin to allocate balance on
        the fly
      </p>
    </section> -->
  </div>
</app-popup-layout>